/* Standard Shopify Constants */
window.accessibilityStrings = {
  activeFilters: "Active filters: ",
  addByMobileNumber: "Add by mobile number",
  addByPhone: "Add by phone",
  addOns: "Add-ons",
  applied: "Applied",
  apply: "Apply",
  backToTop: "Back to top",
  cartError: "There was an error while updating your cart. Please try again.",
  close: "Close",
  copyToClipboard: "Copy to clipboard",
  error: "Error",
  filterAndSort: "Filter and sort",
  loading: "Loading",
  next: "Next",
  of: "of",
  previous: "Previous",
  quantityLabel: "Quantity: [count]",
  recipientFormError: "Recipient form error",
  refresh: "Refresh",
  remove: "Remove",
  resultsFound: "[count] results found",
  search: "Search",
  searchNoResults: "No results found for \"[query]\"",
  searchPlaceholder: "Search",
  share: "Share",
  shareOnFacebook: "Share on Facebook",
  shareOnPinterest: "Share on Pinterest",
  shareOnTwitter: "Share on Twitter",
  slideshowNext: "Next slide",
  slideshowPrevious: "Previous slide",
  sortBy: "Sort by",
  unitPrice: "Unit price",
  unitPriceSeparator: "per",
  variantPlaceholder: "Select variant"
};
